import { Purchases } from '@revenuecat/purchases-js'
import { getValue } from 'firebase/remote-config'
import { ensureConfigActivated, firebaseConfiguration as remoteConfig } from '@/config/analytics'
import { isProd } from '@/constants/Common'

const RC_SANDBOX_KEY = 'rcb_sb_VlLiXajeFuvzJsFqJXyVJUxkv'
const RC_PROD_KEY = 'rcb_SAUTtDYoxKwSehQYekhUhjLWKRoS'

export async function getRevenueCatApiKey(): Promise<string> {
  await ensureConfigActivated()
  const key = getValue(remoteConfig, 'webRevenueCatApiKey').asString()
  if (key) return key
  return isProd ? RC_PROD_KEY : RC_SANDBOX_KEY
}

export class RCPurchaseController {
  private instance: Purchases | null = null

  async initialize(appUserId: string): Promise<void> {
    const apiKey = await getRevenueCatApiKey()
    this.instance = Purchases.configure(apiKey, appUserId)
  }

  getInstance() {
    if (!this.instance) throw new Error('RCPurchaseController not initialized. Call initialize() first.')
    return this.instance
  }

  async getEntitlements(): Promise<string[]> {
    const instance = this.getInstance()
    const customerInfo = await instance.getCustomerInfo()
    return Object.values(customerInfo.entitlements.active).map((e) => e.identifier)
  }
}
